import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import filter from '../../versa/filter.js';
import router from '../../versa/router.js';
import formset from '../../versa/formset.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/replenishment-rules.js';
import form from '../forms/replenishment-rules.js';
import buildReplenishmentGeneratorForm from '../forms/replenishments-create-replenishment.js';
import * as types from '../types.js';
import { resolveTenantCompanyId } from '../utils/tenant-scope.js';

const replenishment_rules = function()
{

	let rules_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_warehouses, this.queryAll()).then((data) => db.set('warehouses', data).catch(error => notify(error)));
			api.call(api.list_products, this.queryAll()).then((data) => db.set('products', data).catch(error => notify(error)));
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_replenishment_rules, query);
		},
		async editFilter() {
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data)).catch(() => {});
			filter.edit(this.applyFilter.bind(this), this.filter);
		},
		async applyFilter(data) {
			this.filter = data;
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data)).catch(() => {});
			this.loadPage(1);
		},
		async loadRecord(id)
		{
			const [company_id, warehouse_id, location_id, product_company_id, product_id] = JSON.parse(id);
			return await api.call(api.select_replenishment_rule,
				company_id, warehouse_id, location_id, product_company_id, product_id);
		},
		async saveRecord(data, old_data)
		{
			const _rule = {
				minimum_quantity: Number(data.minimum_quantity),
				maximum_quantity: Number(data.maximum_quantity),
				is_disabled: data.is_disabled == '1',
			};
			if (old_data)
				return await api.call(api.update_replenishment_rule,
					old_data.company_id, old_data.warehouse_id, old_data.location_id,
					old_data.product_company_id, old_data.product_id,
					_rule);
			return await api.call(api.insert_replenishment_rule,
				data.company_id, data.warehouse_id, {
					location_id: Number(data.location_id),
					product_id: Number(data.product_id),
					minimum_quantity: Number(data.minimum_quantity),
					maximum_quantity: Number(data.maximum_quantity),
					is_disabled: data.is_disabled == '1',
				});
		},
		async createReplenishmentOrder()
		{
			const companyId = await resolveTenantCompanyId(this);
			if (!companyId)
			{
				notify('Não foi possível identificar o tenant: filtre por empresa, selecione uma linha, ou garanta dados na página.', 'Gerar ressuprimento');
				return;
			}
			const showResult = (resp) =>
			{
				notify(resp.id ? 'Ressuprimento criado' : 'Não há posições a ressuprir', 'Resultado');
				this.loadPage();
				fs.destroy();
			};
			const sendRequest = async (data) =>
			{
				const payload = data._payload && Object.keys(data._payload).length ? data._payload : null;
				await api.call(api.insert_replenishment, data.company_id, data.warehouse_id, payload).then(showResult);
			};
			let fs = formset.create(buildReplenishmentGeneratorForm(companyId), sendRequest);
			fs.init();
		},
		async deleteRules()
		{
			const ids = this.getSelection();
			if (!ids.length)
			{
				notify('Selecione ao menos uma regra para excluir.', 'Excluir');
				return;
			}
			ask(`Excluir ${ids.length} regra(s) de ressuprimento?`, 'Confirmar exclusão', async (answer) =>
			{
				if (answer !== 'Y')
					return;
				for (const raw of ids)
				{
					const [company_id, warehouse_id, location_id, product_company_id, product_id] = JSON.parse(raw);
					const r = await api.call(api.delete_replenishment_rule,
						company_id, warehouse_id, location_id, product_company_id, product_id);
					if (r === undefined)
						return;
				}
				notify('Registro(s) excluído(s).', 'Excluir');
				this.clearGridSelection();
				this.loadPage();
			});
		},
	});

	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'warehouse_id', label: 'Armazém', types: [types.datalist()], placeholder: '', title: 'Armazém', store: 'warehouses', labels: ['name'] },
		{ index: 3, field: 'location_id', label: 'Posição', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador da posição' },
		{ index: 4, field: 'product_id', label: 'Produto', types: [types.number(0, 2)], placeholder: '0', title: 'Produto' },
		{ index: 5, field: 'minimum_quantity', label: 'Mínimo', types: [types.number(0, 2)], placeholder: '0', title: 'Quantidade mínima' },
		{ index: 6, field: 'maximum_quantity', label: 'Máximo', types: [types.number(0, 2)], placeholder: '0', title: 'Quantidade máxima' },
		{ index: 7, field: 'is_disabled', label: 'Desativada', types: [types.opt_bool()], placeholder: '', title: 'Regra desativada' },
		{ index: 8, field: 'created_on', label: 'Criação', types: [types.datetime()], placeholder: '', title: 'Data de criação' },
	];

	let operations = [
		{ hash: '#goto-replenishment-orders', label: 'LOG' },
		{ hash: '#run-replenishment-generator', label: 'Gerar&nbsp;ordem' },
		{ hash: '#delete-replenishment-rules', label: 'Excluir' },
	];

	router.set('#run-replenishment-generator', rules_crud.createReplenishmentOrder.bind(rules_crud));
	router.set('#delete-replenishment-rules', rules_crud.deleteRules.bind(rules_crud));

	rules_crud.run(
		'replenishment-rules',
		'Ressuprimentos — regras min/máx',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		[]
	);
};

export default replenishment_rules;
